/** SSE event names shared with the backend EventType enum. */
export const SSE_EVENT_SCOREBOARD_UPDATED = "SCOREBOARD_UPDATED" as const;
export const SSE_EVENT_NEW_IN_APP_NOTIFICATION = "NEW_IN_APP_NOTIFICATION" as const;
